module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ca-Db-Ed-Gd.0df3c10e.png";